import React from 'react';
import moment from 'moment';
import { TableCell, Popup } from 'semantic-ui-react';
import { FiCheckCircle } from 'react-icons/fi';
import { AppState } from 'services/types';
import { useSelector } from 'react-redux';
import {
    FertilizerEventStartDate,
    FertilizerEntityId
} from 'services/fertilizerEvents/types';
import { makeSelectEntityHasBeenAppliedAlready } from './selectors';

export interface Props {
    startDate?: FertilizerEventStartDate;
    entityId: FertilizerEntityId;
}

export default function EntityTableRowAppliedStatusCell(
    props: Props
): React.ReactElement {
    const { startDate } = props;

    const appliedAlready = useSelector((state: AppState) =>
        makeSelectEntityHasBeenAppliedAlready()(state, props)
    );

    return (
        <TableCell textAlign="left" className="events-table-cell-padding">
            {appliedAlready && (
                <Popup
                    trigger={
                        <FiCheckCircle
                            size={22}
                            className="text green"
                            style={{ verticalAlign: 'middle' }}
                        />
                    }
                    content={`Already applied at ${moment(
                        startDate,
                        'YYYY-MM-DD'
                    ).format('DD/MM/YYYY')}`}
                    inverted
                    basic
                    position="top center"
                />
            )}
        </TableCell>
    );
}
